import { useLocation } from "react-router-dom";
import SadLogo from "../assets/sad-logo.png";
export default function Declined() {
    const location = useLocation();

  // Create a URLSearchParams object to easily access query params
  const queryParams = new URLSearchParams(location.search);
  const error = queryParams.get('error'); 
    return (
<div style={{display:"flex",flexDirection:"column",width:"100%",minHeight:"100svh",justifyContent:"center" ,alignItems:"center",backgroundColor:"#F97A7A",gap:"0"}}>
<img src={SadLogo} alt="Sad Logo" style={{height:"150px"}}/>

<h1 style={{fontFamily:"poppins , Arial",color:"white",textAlign:"center", padding:"0 0.5rem 0 0.5rem"}}>Your transaction has been declined</h1>
<p style={{fontFamily:"poppins , Arial",color:"white",textAlign:"center",padding:"0 0.5rem 0 0.5rem"}}>"{!error || error==''? "Unknown Error":error}"</p>
<a href="https://api.whatsapp.com/send?phone=+97333882311&text=Hello%20Lunchy%20team,%20I%20am%20having%20issues%20paying%20for%20my%20subscription." style={{fontFamily:"poppins , Arial",color:"white",textAlign:"center",padding:"0 0.5rem 0 0.5rem"}}>Contact Support</a>

</div>
    );
}
